import { useRef } from 'react';
import LoadingBar from 'react-top-loading-bar';

const TopLoader = () => {
  const ref = useRef(null);

  return (
    <LoadingBar
      color="#007bff"
      ref={ref}
      height={3}
      shadow={true}
    />
  );
};

export default TopLoader;
